import { render } from "./BackBtn.vue?vue&type=template&id=1a6644b9&scoped=true"
import script from "./BackBtn.vue?vue&type=script&lang=js"
export * from "./BackBtn.vue?vue&type=script&lang=js"

import "./BackBtn.vue?vue&type=style&index=0&id=1a6644b9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6644b9"]])

export default __exports__